function customizationModal() {
  var customizationTrigger = document.querySelectorAll('.x-customize-service');
  var serviceModal = document.querySelector('.x-service-modal');

  customizationTrigger.forEach(function (element) {
    if (document.body.contains(element)) {
      element.addEventListener('click', function (event) {
        getCustomizationModal($(event.target).data('url'));
        serviceModal.classList.add('is-visible');
        document.body.classList.add('body-noscroll');
        event.preventDefault();
      });
    }
  });

  customModalClose(serviceModal);
}

function customModalClose(modal) {
  var modalClose = document.querySelector('.x-modal-close');
  if (document.body.contains(modalClose)) {
    modalClose.addEventListener('click', function (event) {
      modal.classList.remove('is-visible');
      document.body.classList.remove('body-noscroll');
      modal.querySelector('.service-customization').innerHTML = '';
      event.preventDefault();
    });
  }
}

function cardDetailsExpand() {
  var serviceCardExpand = document.querySelectorAll('.x-card-expand');
  if (serviceCardExpand.length > 0) {
    serviceCardExpand.forEach(function (element) {
      element.addEventListener('click', function (event) {
        element.textContent = element.textContent === 'Rozwiń listę usług' ? 'Zwiń listę usług' : 'Rozwiń listę usług';
        var serviceCard = element.closest('.x-card');
        serviceCard.classList.toggle('service-card--expanded');
        event.preventDefault();
      });
    });
  }
}

window.bindCustomizationButtons = function bindCustomizationButtons() {
  $('.customization-button').on('click', function () {
    fadeOutServiceModal();
  });
}

window.bindParentElementsSelect = function bindParentElementsSelect() {
  $('.x-selected-child').on('change', function (event) {
    fadeOutServiceModal();
    getCustomizationModal($(event.target).val(), $(event.target).data('components-url'));
    event.preventDefault();
  });
}

function getCustomizationModal(url, components) {
  var xhttp = new XMLHttpRequest();
  xhttp.open('GET', url);
  xhttp.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
  
  xhttp.onreadystatechange = function () {
    if (xhttp.status === 200 && xhttp.readyState === 4) {
      // Bezpieczniejsza alternatywa dla eval()
      try {
        const scriptElement = document.createElement('script');
        scriptElement.setAttribute('nonce', document.querySelector('script[nonce]')?.getAttribute('nonce') || '');
        scriptElement.textContent = xhttp.responseText;
        document.head.appendChild(scriptElement);
      } catch (error) {
        console.error('Error executing script:', error);
      }
    }
  };
  
  xhttp.send();
}

window.fadeInServiceModal = function fadeInServiceModal() {
  $('.service-customization').removeClass('is-loading');
}

function fadeOutServiceModal() {
  $('.service-customization').addClass('is-loading');
}

window.advancedCustomization = function advancedCustomization() {
  var advancedSettings = document.querySelector('.x-advanced-settings');
  var advancedSettingsTrigger = document.querySelector('.x-advanced-settings-trigger');
  if (document.body.contains(advancedSettingsTrigger)) {
    advancedSettingsTrigger.addEventListener('click', function(event) {
      advancedSettings.classList.remove('service-customization__advanced--open', 'service-customization__advanced');
      var expanded = advancedSettingsTrigger.classList.contains('additional-expanded');
      advancedSettingsTrigger.parentNode.remove();
      $('input[name="expanded_additional"]').val(!expanded);

      var rect = advancedSettingsTrigger.getBoundingClientRect();
      if(advancedSettings.classList.contains('service-customization__advanced--open')) {
        document.querySelector('.x-scrollable').scrollTop = 0 + rect.top;
      }

      var scrollable = document.querySelector('.x-scrollable');
      if (document.body.contains(scrollable)) {
        var perfectScroll = new PerfectScrollbar(scrollable, {
          wheelSpeed: 1
        });
      }
      event.preventDefault();
    });
  }
}

function serviceBasicChoice() {
  var serviceName = document.querySelectorAll('.x-service-name');
  var servicePrice = document.querySelector('.x-service-price');
  if (document.body.contains(servicePrice)) {
    serviceName.forEach(function (element) {
      element.addEventListener('change', function () {
        servicePrice.textContent = element.dataset.price;
      });
    });
  }
}

var sidebarUserFeatures = function sidebarUserFeatures() {
  var offerSidebar = document.querySelectorAll('.x-basic-customization-sidebar');
  var pageOverlayer = document.querySelector('.x-page-overlayer');
  var sticky = document.querySelector('.x-sticky-element');

  var featuresList = document.querySelectorAll('.x-features-list');
  var featuresListItem = document.querySelectorAll('.x-features-list-item');
  var featuresListText = document.querySelectorAll('.x-features-more-text');

  var featuresListTrigger = document.querySelectorAll('.x-features-more-trigger');

  var featuresListMobi = document.querySelectorAll('.x-user-features');
  var featuresListTriggerMobi = document.querySelectorAll('.x-features-more-trigger-mobi');

  var promotions = document.querySelector('.x-promotions');

  function sidebarOnTop() {
    offerSidebar.forEach(function(sidebar){
      sidebar.addEventListener('click', function(e){
        sticky.classList.add('sidebar-on-top');
        pageOverlayer.classList.add('is-visible');
        if(document.contains(promotions)) {
          promotions.classList.add('hide');
        }
        e.stopPropagation();
      });
    });
  }

  function featuresListHide() {
    sticky.classList.remove('sidebar-on-top');
    pageOverlayer.classList.remove('is-visible');
    featuresList.forEach(function(features){
      features.classList.remove('is-visible');
    });
    featuresListText.forEach(function(textElem){
      textElem.textContent = 'Rozwiń pozostałe składowe';
    });
    featuresListMobi.forEach(function(list){
      list.classList.remove('is-visible');
    });
    featuresListTriggerMobi.forEach(function(listMobiTrigger){
      listMobiTrigger.classList.remove('hide');
    });
    featuresListTrigger.forEach(function(list){
      list.classList.remove('active');
    });
    if(document.contains(promotions)) {
      promotions.classList.remove('hide');
    }
    hideListItems();
  }

  if(document.contains(pageOverlayer)) {
    pageOverlayer.addEventListener('click', function(){
      featuresListHide();
    });
  }

  if(document.contains(sticky)) {
    sticky.addEventListener('click', function(){
      if (sticky.classList.contains('sidebar-on-top')) {
        featuresListHide();
      }
    });
  }

  function showListItems() {
    featuresListItem.forEach(function(item) {
      item.classList.toggle('is-visible');
    });
  }

  function hideListItems() {
    featuresListItem.forEach(function(item) {
      item.classList.remove('is-visible');
    });
  }

  function featuresExpand() {
    featuresListTrigger.forEach(function(list){
      list.addEventListener('click', function(event) {
        featuresList.forEach(function(features){
          features.classList.toggle('is-visible');
        });
        featuresListText.forEach(function(textElem){
          textElem.textContent = textElem.textContent === 'Rozwiń pozostałe składowe' ? 'Zwiń pozostałe składowe' : 'Rozwiń pozostałe składowe';
        });
        list.classList.toggle('active');
        if(document.contains(promotions)) {
          promotions.classList.add('hide');
        }
        showListItems();
        event.preventDefault();
      });
    });

    featuresListTriggerMobi.forEach(function(mobiListTrigger){
      mobiListTrigger.addEventListener('click', function(event) {
        featuresListMobi.forEach(function(list){
          list.classList.add('is-visible');
        });
        mobiListTrigger.classList.add('hide');
        event.preventDefault();
      });
    });
  }
  sidebarOnTop();
  featuresExpand();
};

function productsModal() {
  var productModal = document.querySelector('.x-product-modal');
  var companyTypeCopartnership = document.querySelector('.x-company-copartnership');
  if(document.body.contains(companyTypeCopartnership)) {
    companyTypeCopartnership.addEventListener('click', function(e) {
      productModal.classList.add('is-visible');
      e.preventDefault();
    });
  }
  customModalClose(productModal);
}

function selectOpen() {
  var selectTrigger = document.querySelectorAll('.x-select-selected');
  var searchFields = document.querySelectorAll('.x-search-field');
  selectTrigger.forEach(function(element){
    element.classList.remove('search-field--active');
    element.addEventListener('click', function(){
      searchFields.forEach(function(fields){
        if(fields !== element.parentElement.parentElement) {
          fields.classList.remove('search-field--active');
        }
      });
      element.parentElement.parentElement.classList.toggle('search-field--active');
    });
  });
}

serviceBasicChoice();
customizationModal();
cardDetailsExpand();
advancedCustomization();
sidebarUserFeatures();
productsModal();
selectOpen();
